import React from "react";
import styles from "./IRLInfo.module.css";
import irlImage from "../../../assets/images/robotics/AboutUs.png";
import bg1 from "../../../assets/images/bg/bg1.png";
const IRLInfo = () => {
  return (
    <div className={styles.IRLINfo} id="about-irl">
      <div className={styles.aboutUsHeading}>
        <h1>
          About{" "}
          <span className={styles.highlight}>Indian Robotics League(IRL)</span>
        </h1>
      </div>
      <section className={styles.irlSection}>
        <div className={styles.textContainer}>
          <div className={styles.standFor}>
            <h3>WHAT IS IRL?</h3>
            <h2>
              IRL is a Robotics Competition in India, committed to advancing
              Science, Technology, and Engineering.
            </h2>
          </div>
          <div className={styles.missionVision}>
            <div className={styles.mission}>
              <h3>OUR MISSION</h3>
              <h4>Empowering Creativity and Problem Solving</h4>
              <p>
                Our mission is to help young people develop their creativity and
                problem solving skills in a fun and engaging way.
              </p>
            </div>
            <div className={styles.vision}>
              <h3>OUR VISION</h3>
              <h4>A Nationwide STEM Robotics Festival</h4>
              <p>
                INDIA ROBOTICS LEAGUE (IRL) hosted by BHARATHI STEM TRUST (BST)
                across India is a festival of competitions and events with
                autonomous robots that encourages students to have fun while
                learning principles of Science, Technology, Engineering, and
                Mathematics (STEM)
              </p>
            </div>
          </div>
        </div>
        <div className={styles.imagePlaceholder}>
          <img src={irlImage} alt="IRL" />
        </div>
      </section>
    </div>
  );
};

export default IRLInfo;
